class AppStartTime {
	constructor() {
		try {
			let lastActivityTimeStr = window.localStorage.lastActivityTime;
			if (lastActivityTimeStr)
				this.lastActivityTime = new Date(lastActivityTimeStr);
		} catch (e) { }
		if (!this.lastActivityTime) {
			this.lastActivityTime = new Date();
			this.lastActivityTime = new Date(this.lastActivityTime.setDate(this.lastActivityTime.getDate() - 1));
		}
		this.storeLastTime();
		window.setInterval(() => { this.storeLastTime(); }, 1000 * 5);
	}

	getLastTime() {
		return this.lastActivityTime;
	}

	storeLastTime() {
		try {
			window.localStorage.lastActivityTime = new Date().toString();
		} catch (e) {}
	}
}

export let appStartTime = new AppStartTime();